export default __webpack_public_path__ + "static/media/bg3.8daaf089.svg";